import { render, staticRenderFns } from "./ControleDeInsumos.vue?vue&type=template&id=9e568ffe&scoped=true"
import script from "./ControleDeInsumos.vue?vue&type=script&lang=js"
export * from "./ControleDeInsumos.vue?vue&type=script&lang=js"
import style0 from "./ControleDeInsumos.vue?vue&type=style&index=0&id=9e568ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e568ffe",
  null
  
)

export default component.exports